import React, { useEffect } from "react";

const TerminosCondiciones = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="min-h-screen bg-gray-50 pt-24 pb-16 font-dmSans">
            <div className="max-w-4xl mx-auto px-5">
                <div className="bg-white rounded-[24px] shadow-sm border border-gray-100 p-8 md:p-12">
                    <div className="mb-10 border-b border-gray-100 pb-8">
                        <h1 className="text-3xl md:text-4xl font-bold text-[#7A1B29] mb-3">
                            Términos y Condiciones
                        </h1>
                        <p className="text-gray-500">Última actualización: {new Date().toLocaleDateString('es-AR')}</p>
                    </div>

                    <div className="space-y-8 text-gray-700 leading-relaxed">
                        <section>
                            <h2 className="text-xl font-bold text-gray-900 mb-3">1. Información Legal y Responsabilidad</h2>
                            <p>
                                El presente sitio web es operado y administrado bajo la titularidad legal de <strong>Karina Peralta Galvan</strong>, Martillera Pública Nacional Colegiada (M.P. 729). Al utilizar este sitio web, usted acepta los presentes términos y condiciones en su totalidad.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-gray-900 mb-3">2. Naturaleza de la Información Publicada</h2>
                            <p>
                                Toda la información proporcionada en esta plataforma web (incluyendo, pero no limitándose a, precios, medidas, superficies, características de los inmuebles, imágenes, planos y disponibilidad) tiene un propósito <strong>estrictamente informativo y orientativo</strong>.
                            </p>
                            <p className="mt-2">
                                Dichos datos no constituyen una oferta vinculante ni un documento contractual. Inmobiliaria D'Williams se reserva el derecho de modificar o actualizar cualquier información en cualquier momento sin previo aviso.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-gray-900 mb-3">3. Medidas y Valores</h2>
                            <p>
                                Las medidas, superficies y proporciones expresadas en las fichas de las propiedades son aproximadas y han sido suministradas por los propietarios. Las medidas reales exactas surgirán del respectivo título de propiedad y de los planos aprobados. Los valores de impuestos, expensas y servicios indicados están sujetos a verificación y/o revisión.
                            </p>
                            <p className="mt-2">
                                Los precios indicados (ya sea en Pesos Argentinos o Dólares Estadounidenses) pueden ser modificados por los propietarios sin previo aviso.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-gray-900 mb-3">4. Propiedad Intelectual</h2>
                            <p>
                                Todo el contenido de este sitio web, incluyendo textos, logotipos, fotografías, diseños y software, está protegido por las leyes de propiedad intelectual y derechos de autor vigentes en la República Argentina. Queda prohibida su reproducción total o parcial sin autorización expresa de la administración.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-gray-900 mb-3">5. Jurisdicción y Ley Aplicable</h2>
                            <p>
                                Para cualquier controversia legal o disputa que pudiera derivarse del uso de este sitio web o de las operaciones originadas a través del mismo, las partes se someterán a la jurisdicción de los <strong>Tribunales Ordinarios de la Ciudad de San Luis, Provincia de San Luis, República Argentina</strong>, renunciando expresamente a cualquier otro fuero o jurisdicción que pudiera corresponderles.
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default TerminosCondiciones;